"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setMessage = exports.reset = exports.getLastMessage = exports.getAll = void 0;
var _stats = {
    messages: [],
};
var getAll = function () {
    return _stats.messages;
};
exports.getAll = getAll;
var getLastMessage = function (oy) {
    return _stats.messages[_stats.messages.length - 1 - oy] || '';
};
exports.getLastMessage = getLastMessage;
var reset = function () {
    _stats.messages = [];
};
exports.reset = reset;
var setMessage = function (message) {
    if (_stats.messages.length > 0) {
        var lastMessage = _stats.messages[_stats.messages.length - 1];
        if (lastMessage.startsWith(message)) {
            var count = 1;
            var idx = lastMessage.lastIndexOf('x');
            if (idx > 0) {
                count = parseInt(lastMessage.substring(idx + 1));
                if (isNaN(count)) {
                    count = 1;
                }
            }
            count++;
            _stats.messages[_stats.messages.length - 1] = message + ' x' + count;
            return;
        }
    }
    _stats.messages.push(message);
    if (_stats.messages.length > 10) {
        _stats.messages.shift();
    }
};
exports.setMessage = setMessage;
